import { Routes, Route, Navigate } from 'react-router-dom';
import { StaffAuthProvider } from './contexts/StaffAuthContext';

// Pages
import PublicStatus from './pages/PublicStatus';
import StaffLogin from './pages/StaffLogin';
import StaffDashboard from './pages/StaffDashboard';

// Components
import ProtectedRoute from './components/common/ProtectedRoute';

function App() {
  return (
    <StaffAuthProvider>
      <Routes>
        {/* Public Status Page - No Authentication */}
        <Route path="/" element={<PublicStatus />} />
        <Route path="/incidents" element={<PublicStatus />} />
        <Route path="/incidents/:id" element={<PublicStatus />} />
        <Route path="/subscribe" element={<PublicStatus />} />

        {/* Staff Authentication */}
        <Route path="/staff/login" element={<StaffLogin />} />

        {/* Staff Dashboard - Protected Routes */}
        <Route
          path="/staff/*"
          element={
            <ProtectedRoute>
              <StaffDashboard />
            </ProtectedRoute>
          }
        />

        {/* Redirect unknown routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </StaffAuthProvider>
  );
}

export default App;
